import { useMemo } from 'react';
import { Theme } from '@mui/material/styles';
import { useTheme } from '@mui/material';
import useDesignTokens from '@assetron/web-common/themes/useDesignTokens';

export const usePlansStyles = (
  titleSpacing: 'xs' | 'lg' = 'lg',
  contentGap: 'xs' | 'lg' = 'lg',
) => {
  const theme: Theme = useTheme();
  const tokens = useDesignTokens();

  return useMemo(
    () => ({
      titleContainer: {
        flex: contentGap === 'lg' ? '1 0 0' : '0 0 auto',
        display: 'flex',
        flexDirection: 'column',
        padding:
          contentGap === 'lg'
            ? `${theme.sizeGuide['4xl']} ${theme.sizeGuide['4xl']} ${theme.sizeGuide['10xl']} ${theme.sizeGuide['4xl']}`
            : `${theme.sizeGuide['4xl']} ${theme.sizeGuide['4xl']} ${theme.sizeGuide['6xl']} ${theme.sizeGuide['4xl']}`,
        alignItems: 'center',
        justifyContent: contentGap === 'lg' ? 'center' : 'flex-start',
        gap: contentGap === 'lg' ? theme.sizeGuide['4xl'] : theme.sizeGuide.lg,
      },
      subtitleContainer: {
        textAlign: 'center',
        lineHeight: 1,
      },
      descriptionContainer: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: titleSpacing === 'lg' ? theme.sizeGuide.lg : theme.sizeGuide.xs,
      },
      title: {
        color: tokens.colors.text.primary,
      },
      subtitle: {
        color: tokens.colors.text.secondary,
      },
      contentContainer: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      },
    }),
    [theme, tokens, titleSpacing, contentGap],
  );
};
